import * as internalAlertTypes from "./alertTypes";
import { internalAlertService } from "../services/internalAlert.service";
import { followingOnAlertsService } from "../services/followingOnAlerts.service";
import { followingOnNotificationService } from "../services/followingOnNotification.service";
import { customerList } from "../services/customerlist.service";
import { CustomerGroups } from "../services/customerGroups.service";
export const resetAllAlerts = () => (dispatch) => {
  dispatch({
    type: internalAlertTypes.RESET_ALERTS,
  });
};

export const getMessageTypes = (error) => async (dispatch) => {
  try {
    const res = await internalAlertService.getMessageTypes();

    if (res.data.responseCode === "SUCCESS") {
      dispatch({
        type: internalAlertTypes.MESSAGE_TYPE,
        payload: res.data.returnObject,
        // payload: banks,
      });
    } else {
      error(res.data.message);
    }
  } catch (e) {
    error(e.message);
  }
};
export const getTemplates = (error) => async (dispatch) => {
  try {
    const res = await internalAlertService.getTemplates();

    if (res.data.responseCode === "SUCCESS") {
      dispatch({
        type: internalAlertTypes.TEMPLATES,
        payload: res.data.returnObject,
        // payload: banks,
      });
    } else {
      error(res.data.message);
    }
  } catch (e) {
    console.log(error);
    error(e.message);
  }
};

export const getcurrency = (error) => async (dispatch) => {
  try {
    const res = await internalAlertService.getcurrency();

    if (res.data.responseCode === "SUCCESS") {
      dispatch({
        type: internalAlertTypes.CURRENCY,
        payload: res.data.returnObject,
        // payload: banks,
      });
    } else {
      error(res.data.message);
    }
  } catch (e) {
    error(e.message);
  }
};

export const getInternalAlerts =
  (current = true, error) =>
  async (dispatch) => {
    if (current) {
      dispatch({ type: internalAlertTypes.LOAD_ALERTS });
    }

    try {
      const res = await internalAlertService.getInternalAlerts();

      if (res.data.responseCode === "SUCCESS") {
        dispatch({
          type: internalAlertTypes.GET_ALERTS,
          payload: res.data.returnObject,
        });
      } else {
        error(res.data.message);
      }
    } catch (e) {
      error(e.message);
    }
  };

export const updateCriteria =
  (data, success, error) => async (dispatch, getState) => {
    try {
      const res = await internalAlertService.updateCriteria(data);

      if (res.data.responseCode === "SUCCESS") {
        success(res.data.message);

        /*  dispatch({
          type: internalAlertTypes.UPDATE_ALERT,
          payload: res.data.returnObject,
        });  */
      } else {
        error(res.data.message);
      }
    } catch (e) {
      error(e.message);
    }
  };

export const createCriteria =
  (data, success, error) => async (dispatch, getState) => {
    try {
      const res = await internalAlertService.createCriteria(data);

      if (res.data.responseCode === "SUCCESS") {
        success(res.data.message);

        dispatch({
          type: internalAlertTypes.CREATE_CRI,
          payload: res.data.returnObject,
        });
      } else {
        error(res.data.message);
      }
    } catch (e) {
      error(error.message);
    }
  };

export const deleteCriteria =
  (data, success, error) => async (dispatch, getState) => {
    try {
      const res = await internalAlertService.deleteCriteria(data);

      if (res.data.responseCode === "SUCCESS") {
        success(res.data.message);

        dispatch({
          type: internalAlertTypes.DELETE_CRI,
          payload: data,
        });
      } else {
        error(res.data.message);
      }
    } catch (e) {
      error(e.message);
    }
  };

export const getField = (data) => async (dispatch) => {
  try {
    const res = await internalAlertService.getFields(data);
    if (res.data.responseCode === "SUCCESS") {
      dispatch({
        type: internalAlertTypes.GET_Fields,
        payload: res.data.returnObject,
      });
    } else {
    }
  } catch (error) {
    console.log(error);
  }
};

/* FOLLOWING ON ALERT */

export const resetFollowingAlerts = () => (dispatch) => {
  dispatch({
    type: internalAlertTypes.RESET_INTERNAL_ALERTS,
  });
};

export const getFollowingAlerts = (data, error) => async (dispatch) => {
  try {
    dispatch({ type: internalAlertTypes.SET_PROCESSING_INTERNAL_ALERTS });
    const res = await followingOnAlertsService.getFollowingAlerts(data);
    if (res.data.responseCode === "SUCCESS") {
      dispatch({
        type: internalAlertTypes.SEARCH_INTERNAL_ALERTS,
        payload: {
          ...res.data.returnObject,
          pageNumber: data.pageNumber,
          pageSize: data.pageSize,
        },
      });
      console.log(res.data);
    } else {
      dispatch({
        type: internalAlertTypes.SEARCH_INTERNAL_ALERTS,
        payload: null,
        error: res.data.message,
      });

      error(res.data.message);
    }
  } catch (e) {
    dispatch({
      type: internalAlertTypes.SEARCH_INTERNAL_ALERTS,
      payload: null,
      error: e.message,
    });

    error(e.message);
  }
};

export const reGenerateAlert = (data, error, success) => async (dispatch) => {
  try {
    const res = await followingOnAlertsService.reGenerateAlert(data);

    if (res.data.responseCode === "SUCCESS") {
      success(res.data.message);
    } else {
      error(res.data.message);
    }
  } catch (e) {
    error(e.message);
  }
};

/* FOLLOWING ON Notification */

export const resetFollowingNotifications = () => (dispatch) => {
  dispatch({
    type: internalAlertTypes.RESET_INTERNAL_NOTIFICATOIN,
  });
};

export const getFollowingNotification = (data, error) => async (dispatch) => {
  try {
    dispatch({ type: internalAlertTypes.SET_PROCESSING_INTERNAL_NOTIFICATOIN });
    const res = await followingOnNotificationService.getFollowingNotifications(
      data
    );
    if (res.data.responseCode === "SUCCESS") {
      dispatch({
        type: internalAlertTypes.SEARCH_INTERNAL_NOTIFICATOIN,
        payload: {
          ...res.data.returnObject,
          pageNumber: data.pageNumber,
          pageSize: data.pageSize,
        },
      });
      console.log(res.data);
    } else {
      dispatch({
        type: internalAlertTypes.SEARCH_INTERNAL_NOTIFICATOIN,
        payload: null,
        error: res.data.message,
      });

      error(res.data.message);
    }
  } catch (e) {
    dispatch({
      type: internalAlertTypes.SEARCH_INTERNAL_NOTIFICATOIN,
      payload: null,
      error: e.message,
    });

    error(e.message);
  }
};

export const reGenerateNotification =
  (data, error, success) => async (dispatch) => {
    try {
      const res = await followingOnNotificationService.reGenerateNotification(
        data
      );

      if (res.data.responseCode === "SUCCESS") {
        success(res.data.message);
      } else {
        error(res.data.message);
      }
    } catch (e) {
      error(e.message);
    }
  };

/* CUSTOMERS SUBSCRIBERS */

export const Resetnotification = () => async (dispatch) => {
  dispatch({
    type: internalAlertTypes.RESET_CUSTOMER_LIST,
  });
};

export const getGroups = (error) => async (dispatch) => {
  try {
    const res = await customerList.getGroups();

    if (res.data.responseCode === "SUCCESS") {
      dispatch({
        type: internalAlertTypes.GROUPS,
        payload: res.data.returnObject,
        // payload: banks,
      });
    } else {
      error(res.data.message);
    }
  } catch (e) {
    console.log(error);
    error(e.message);
  }
};

export const AddGroupUser =
  (customerData, success, error) => async (dispatch) => {
    try {
      const res = await customerList.AddGroupUser(customerData);
      if (res.data.responseCode === "SUCCESS") {
        success(res.data.message);
      } else {
        error(res.data.message);
      }
    } catch (e) {
      console.log(error);
      error(e.message);
    }
  };

export const EditGroupUser = (data, success, error) => async (dispatch) => {
  try {
    const res = await customerList.EditGroupUser(data);
    if (res.data.responseCode === "SUCCESS") {
      success(res.data.message);
    } else {
      error(res.data.message);
    }
  } catch (e) {
    console.log(error);
    error(e.message);
  }
};

export const AddSingleUser =
  (customerData, success, error) => async (dispatch) => {
    try {
      const res = await customerList.AddSingleUser(customerData);
      if (res.data.responseCode === "SUCCESS") {
        success(res.data.message);
      } else {
        error(res.data.message);
      }
    } catch (e) {
      console.log(error);
      error(e.message);
    }
  };

export const LoadSubscribers = (data, error) => async (dispatch) => {
  dispatch({ type: internalAlertTypes.SET_PROCESSING_CUSTOMER_LIST });
  try {
    const res = await customerList.LoadSubscribers(data);
    if (res.data.responseCode === "SUCCESS") {
      dispatch({
        type: internalAlertTypes.SEARCH_CUSTOMER_LIST,
        payload: {
          ...res.data.returnObject,
          pageNumber: data.pageNumber,
          pageSize: data.pageSize,
        },
      });
      console.log(res.data);
    } else {
      dispatch({
        type: internalAlertTypes.SEARCH_CUSTOMER_LIST,
        payload: null,
        error: res.data.message,
      });

      error(res.data.message);
    }
  } catch (e) {
    dispatch({
      type: internalAlertTypes.SEARCH_CUSTOMER_LIST,
      payload: null,
      error: e.message,
    });

    error(e.message);
  }
};

export const SelectedUser = (data) => (dispatch) => {
  dispatch({
    type: internalAlertTypes.SELECTED_USER,
    payload: data,
  });
};

export const CheckTheStatus = (data, success, error) => async (dispatch) => {
  try {
    const res = await customerList.CheckStatus(data);
    if (res.data.responseCode === "SUCCESS") {
      success(res.data.message);
    } else {
      error(res.data.message);
    }
  } catch (e) {
    error(e.message);
  }
};

export const DeleteTheCustomer = (data, success, error) => async (dispatch) => {
  try {
    const res = await customerList.DeleteCustomer(data);
    if (res.data.responseCode === "SUCCESS") {
      success(res.data.message);
    } else {
      error(res.data.message);
    }
  } catch (e) {
    error(e.message);
  }
};

export const AssginmultiplesGroup =
  (data, success, error) => async (dispatch) => {
    try {
      const res = await customerList.AssginmultiplesGroup(data);

      if (res.data.responseCode === "SUCCESS") {
        success(res.data.message);
        dispatch({ type: "ADD_GROUP", payload: res.data.returnObject[0] });
      } else {
        error(res.data.message);
      }
    } catch (e) {
      error(e.message);
    }
  };

/* GROUPS */

export const AssginCustomersToGroup =
  (data, success, error) => async (dispatch) => {
    try {
      const res = await CustomerGroups.AssginToGroup(data);

      if (res.data.responseCode === "SUCCESS") {
        success(res.data.message);
        // dispatch({type:"ADD_GROUP",payload:res.data.returnObject[0]})
      } else {
        error(res.data.message);
      }
    } catch (e) {
      error(e.message);
    }
  };

export const resetAllGroups = () => async (dispatch) => {
  dispatch({ type: internalAlertTypes.RESET_GROUPS });
};

export const getConfiguration = (error) => async (dispatch) => {
  try {
    const res = await customerList.getConfiguration();

    if (
      res.data.responseCode === "SUCCESS" ||
      res.data.responseCode === "LICENSE_WARNING"
    ) {
      dispatch({
        type: internalAlertTypes.GET_CONFIGURATION,
        payload: res.data.returnObject,
      });
    } else if (res.data.responseCode === "VALIDATION_ERROR") {
      error(res.data.message);
    }
  } catch (error) {
    console.log(error);
  }
};

export const GroupList =
  (current = false, error) =>
  async (dispatch) => {
    if (current) {
      dispatch({ type: internalAlertTypes.LOAD_NOTIFICATION });
    }

    try {
      const res = await CustomerGroups.GroupList();

      if (res.data.responseCode === "SUCCESS") {
        dispatch({
          type: internalAlertTypes.All_GROUPS,
          payload: res.data.returnObject,
        });
      } else {
        error(res.data.message);
      }
    } catch (e) {
      error(e.message);
    }
  };

export const CreateGroup = (data, success, error) => async (dispatch) => {
  try {
    const res = await CustomerGroups.CreateGroups(data);

    if (res.data.responseCode === "SUCCESS") {
      success(res.data.message);

      dispatch({
        type: "ADD_GROUP",
        payload: res.data.returnObject,
      });
    } else {
      error(res.data.message);
    }
  } catch (e) {
    error(error.message);
  }
};

export const RemoveGroup = (data, success, error) => async (dispatch) => {
  try {
    const res = await CustomerGroups.RemoveGroup(data);

    if (res.data.responseCode === "SUCCESS") {
      dispatch({
        type: internalAlertTypes.DELETE_GROUP,
        payload: data,
      });
      success(res.data.message);
    } else {
      error(res.data.message);
    }
  } catch (e) {
    error(error.message);
  }
};

export const EditGroup = (data, success, error) => async (dispatch) => {
  try {
    const res = await CustomerGroups.EditGroup(data);
    if (res.data.responseCode === "SUCCESS") {
      success(res.data.message);

      dispatch({
        type: "ADD_GROUP",
        payload: res.data.returnObject,
      });
    } else {
      error(res.data.message);
    }
  } catch (e) {
    error(error.message);
  }
};

export const CustomersList = (data, error) => async (dispatch) => {
  const res = await CustomerGroups.LoadSubscribers(data);
  try {
    if (res.data.responseCode === "SUCCESS") {
      dispatch({
        type: internalAlertTypes.CUSTOMERS_LIST,
        payload: {
          ...res.data.returnObject,
        },
      });
      console.log(res.data);
    } else {
      error(res.data.message);
    }
  } catch (e) {
    error(e.message);
  }
};

export const GetSubscriberByGroup = (data, error) => async (dispatch) => {
  dispatch({ type: internalAlertTypes.SET_PROCESSING_SUBSCRIBERS_GROUP });
  try {
    const res = await CustomerGroups.GetSubscriberByGroup(data);

    if (res.data.responseCode === "SUCCESS") {
      dispatch({
        type: internalAlertTypes.CUSTOMERS_IN_GROUP,
        payload: {
          ...res.data.returnObject,
          pageNumber: data.pageNumber,
          pageSize: data.pageSize,
        },
      });
      console.log(res.data);
    } else {
      dispatch({
        type: internalAlertTypes.CUSTOMERS_IN_GROUP,
        payload: null,
        error: res.data.message,
      });

      error(res.data.message);
    }
  } catch (e) {
    dispatch({
      type: internalAlertTypes.CUSTOMERS_IN_GROUP,
      payload: null,
      error: e.message,
    });

    error(e.message);
  }
};

export const removeCustomerFromGRoup =
  (data, success, error) => async (dispatch) => {
    try {
      const res = await CustomerGroups.RemoveCustomerFromGroup(data);
      if (res.data.responseCode === "SUCCESS") {
        success(res.data.message);
      } else {
        error(res.data.message);
      }
    } catch (e) {
      error(e.message);
    }
  };
